// src/pages/tenant/TenantSpacePage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ListChecks,
  FilePlus2,
  Bot,
  FilePenLine,
  Mail,
  ClipboardList, // 👉 nouvelle icône pour toutes les doléances
} from "lucide-react";
import "../../styles/TenantSpacePage.css";

const TenantSpacePage = () => {
  const navigate = useNavigate();

  // 👉 Routes qui existent dans AppRoutes.jsx
  const handleGoToAllGrievances = () => navigate("/my-grievances");
  const handleGoToNewGrievance = () => navigate("/grievances");
  const handleGoToAskAI = () => navigate("/chat-ia");
  const handleGoToLetterHelp = () => navigate("/letter-generator");
  const handleGoToContact = () => navigate("/contact");

  // 👉 Nouvelle route "Toutes les doléances"
  const handleGoToGlobalGrievances = () => navigate("/all-grievances");

  return (
    <div className="tenant-space">
      <div className="tenant-space-header">
        <h1>Espace Locataire</h1>
        <p>
          Retrouvez ici tous vos outils pour défendre vos droits, suivre vos
          réclamations et obtenir de l’aide rapidement.
        </p>
      </div>

      <div className="tenant-space-grid">
        {/* 1. Toutes mes réclamations */}
        <div className="tenant-card">
          <div className="tenant-card-icon">
            <ListChecks size={32} />
          </div>
          <h2>Toutes mes réclamations</h2>
          <p>
            Consultez votre historique personnel, les statuts et les réponses reçues.
          </p>
          <button
            className="tenant-card-button"
            onClick={handleGoToAllGrievances}
          >
            Voir mes réclamations
          </button>
        </div>

        {/* 2. Nouvelle réclamation */}
        <div className="tenant-card">
          <div className="tenant-card-icon">
            <FilePlus2 size={32} />
          </div>
          <h2>Nouvelle réclamation</h2>
          <p>
            Déclarez un problème dans votre logement ou votre immeuble.
          </p>
          <button
            className="tenant-card-button"
            onClick={handleGoToNewGrievance}
          >
            Faire un signalement
          </button>
        </div>

        {/* 3. Poser une question à l’IA */}
        <div className="tenant-card">
          <div className="tenant-card-icon">
            <Bot size={32} />
          </div>
          <h2>Poser une question à l’IA</h2>
          <p>
            Obtenez une réponse instantanée sur vos droits et vos démarches.
          </p>
          <button
            className="tenant-card-button"
            onClick={handleGoToAskAI}
          >
            Parler à l’IA
          </button>
        </div>

        {/* 4. Aide pour un courrier */}
        <div className="tenant-card">
          <div className="tenant-card-icon">
            <FilePenLine size={32} />
          </div>
          <h2>Aide pour un courrier</h2>
          <p>
            Générez automatiquement une lettre adaptée à votre situation.
          </p>
          <button
            className="tenant-card-button"
            onClick={handleGoToLetterHelp}
          >
            Créer mon courrier
          </button>
        </div>

        {/* 5. Nous contacter */}
        <div className="tenant-card">
          <div className="tenant-card-icon">
            <Mail size={32} />
          </div>
          <h2>Nous contacter</h2>
          <p>
            Besoin d’un accompagnement humain ? Contactez l’équipe NMS 06.
          </p>
          <button
            className="tenant-card-button"
            onClick={handleGoToContact}
          >
            Contacter NMS 06
          </button>
        </div>

        {/* 6. ▶▶ Nouvelle card : Toutes les doléances (AllGrievancesPage) */}
        <div className="tenant-card">
          <div className="tenant-card-icon">
            <ClipboardList size={32} />
          </div>
          <h2>Toutes les doléances (globale)</h2>
          <p>
            Accédez à la liste complète des doléances déclarées dans la plateforme (vue générale).
          </p>
          <button
            className="tenant-card-button"
            onClick={handleGoToGlobalGrievances}
          >
            Voir toutes les doléances
          </button>
        </div>
      </div>
    </div>
  );
};

export default TenantSpacePage;
